import { JsonObject, JsonProperty } from 'json2typescript';

import { Id } from './id';
import { IdAdapter } from '../../client/helpers/serializer/adapters/id.adapter';
import { QuestionGroup } from './question-group';
import { QuestionInterface } from '../../../core';
import { QuestionOption } from './question-option';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Question')
export class Question implements QuestionInterface {
    @JsonProperty('Id', IdAdapter, true)
    private _id: Id = undefined;

    @JsonProperty('Description', StringAdapter, true)
    private _description: string = undefined;

    @JsonProperty('Order', Number, true)
    private _order: number = undefined;

    @JsonProperty('Options', [QuestionOption], true)
    private _options: QuestionOption[] = undefined;

    @JsonProperty('Groups', [QuestionGroup], true)
    private _groups: QuestionGroup[] = undefined;

    get id(): Id {
        return this._id;
    }

    get description(): string {
        return this._description;
    }

    get order(): number {
        return this._order;
    }

    get options(): QuestionOption[] {
        if (!this._options) {
            this._options = [];
        }

        return this._options.sort((a: QuestionOption, b: QuestionOption) => {
            if (a.order < b.order) {
                return -1;
            } else if (a.order > b.order) {
                return 1;
            }

            return 0;
        });
    }

    get groups(): QuestionGroup[] {
        if (!this._groups) {
            this._groups = [];
        }

        return this._groups;
    }

    get groupsOptions(): QuestionOption[] {
        const options = [];

        this.groups.map((group) => {
            group.options.map((option) => {
                options.push(option);
            });
        });

        return options;
    }
}
